import React, {
  useEffect,
  useContext,
  useState
} from 'react';
import clsx from 'clsx';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  makeStyles,
} from '@material-ui/core';

import { useHttpClient } from '../../../../hooks/http-hook';
import { AuthContext } from '../../../../shared/context/auth-context';
import LoadingSpinner from '../../../../shared/component/UIElements/LoadingSpinner';
import ErrorMessage from '../../../../shared/component/UIElements/ErrorMessage';

const Numeros = (props) => {
  const { colunas } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.background.dark,
      minHeight: '100%',
      paddingBottom: theme.spacing(3),
      paddingTop: theme.spacing(3)
    },
    header: {
      border: '1px solid #ACACAC',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      '& .MuiCardHeader-title': {
        fontSize: '20px',
        fontWeight: 700,
        fontFamily: 'Roboto',
        color: '#3E3E3E'
      }
    },
    container: {
      borderLeft: '1px solid #ACACAC',
      borderRight: '1px solid #ACACAC',
      borderBottom: '1px solid #ACACAC',
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      padding: '0px 0px 0px 0px',
      '&:last-child': {
        paddingBottom: 0
      }
    },
    box: {
      flexGrow: 1,
    },
    numero: {
      fontSize: '45px',
      fontWeight: 500,
      color: '#3E3E3E',
      textAlign: 'center'
    },
    descricao: {
      fontSize: '21px',
      fontWeight: 700,
      color: '#808080',
      textAlign: 'center',
      maxWidth: '166px',
      lineHeight: '21px'
    },
    borda: {
      borderRight: '1px solid #ACACAC'
    },
    bordaesquerda: {
      borderRight: '1px solid #ACACAC',
      borderBottom: '1px solid #ACACAC'
    },
    bordadireita: {
      borderBottom: '1px solid #ACACAC'
    },
    acessos: {
      marginTop: '18px'
    },
    titulo: {
      fontSize: '33px',
      fontWeight: 500,
      color: '#3E3E3E',
      textAlign: 'left'
    },
    topo: {
      margin: '25px 0px'
    },
    altura: {
      height: '100%'
    }
  }));
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [relatorios, setRelatorios] = useState({
    cadastrados: 0,
    emprestados: 0,
    exibicao: 0,
    reserva: 0
  });
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  useEffect(() => {
    const fetchRelatorios = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/relatorios/`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        if (responseData.sucesso) {
          setRelatorios(responseData.data);
          clearError();
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchRelatorios();
  }, [sendRequest, auth]);

  if (isLoading) {
    return (
      <>
        <LoadingSpinner asOverlay />
      </>
    );
  }

  let tabela = <></>;

  switch (colunas) {
    case 2:
      tabela = (
        <Card>
          <CardHeader
            title="Acervo em Números"
            className={classes.header}
          />
          <CardContent
            className={classes.container}
          >
            <Box
              height={200}
              position="relative"
              display="flex"
              justifyContent="center"
              alignContent="center"
            >
              <Box
                className={clsx(classes.box, classes.bordaesquerda)}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.cadastrados}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens Cadastrados
                  </Typography>
                </Box>
              </Box>
              <Box
                className={clsx(classes.box, classes.bordadireita)}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.emprestados}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens Emprestados
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              height={200}
              position="relative"
              display="flex"
              justifyContent="center"
              alignContent="center"
            >
              <Box
                className={clsx(classes.box, classes.bordaesquerda)}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.exibicao}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens em Exibição
                  </Typography>
                </Box>
              </Box>
              <Box
                className={clsx(classes.box, classes.bordadireita)}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.reserva}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens em Reserva Técnica
                  </Typography>
                </Box>
              </Box>
            </Box>
            <ErrorMessage error={error} onClear={clearError} />
          </CardContent>
        </Card>
      );
      break;
    default:
      tabela = (
        <Card>
          <CardHeader
            title="Acervo em Números"
            className={classes.header}
          />
          <CardContent
            className={classes.container}
          >
            <Box
              height={200}
              position="relative"
              display="flex"
              justifyContent="center"
              alignContent="center"
            >
              <Box
                className={clsx(classes.box, classes.borda)}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.cadastrados}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens Cadastrados
                  </Typography>
                </Box>
              </Box>
              <Box
                className={clsx(classes.box, classes.borda)}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.emprestados}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens Emprestados
                  </Typography>
                </Box>
              </Box>
              <Box
                className={clsx(classes.box, classes.borda)}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.exibicao}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens em Exibição
                  </Typography>
                </Box>
              </Box>
              <Box
                className={classes.box}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.numero}
                  >
                    {relatorios.reserva}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    className={classes.descricao}
                  >
                    Itens em Reserva Técnica
                  </Typography>
                </Box>
              </Box>
            </Box>
            <ErrorMessage error={error} onClear={clearError} />
          </CardContent>
        </Card>
      );
      break;
  }

  return (
    <>
      {tabela}
    </>
  );
};

export default Numeros;
